export const States = [
  {
    key: 226670001,
    value: 226670001,
    text: "N/A",
  },
  {
    key: 100000000,
    value: 100000000,
    text: "CA",
  },
  {
    key: 100000002,
    value: 100000002,
    text: "AK",
  },
  {
    key: 100000001,
    value: 100000001,
    text: "AL",
  },
  {
    key: 100000004,
    value: 100000004,
    text: "AR",
  },
  {
    key: 100000003,
    value: 100000003,
    text: "AZ",
  },
  {
    key: 100000005,
    value: 100000005,
    text: "CO",
  },
  {
    key: 100000006,
    value: 100000006,
    text: "CT",
  },
  {
    key: 100000007,
    value: 100000007,
    text: "DE",
  },
  {
    key: 100000008,
    value: 100000008,
    text: "FL",
  },
  {
    key: 100000009,
    value: 100000009,
    text: "GA",
  },
  {
    key: 100000010,
    value: 100000010,
    text: "HI",
  },
  {
    key: 100000014,
    value: 100000014,
    text: "IA",
  },
  {
    key: 100000011,
    value: 100000011,
    text: "ID",
  },
  {
    key: 100000012,
    value: 100000012,
    text: "IL",
  },
  {
    key: 100000013,
    value: 100000013,
    text: "IN",
  },
  {
    key: 100000015,
    value: 100000015,
    text: "KS",
  },
  {
    key: 100000016,
    value: 100000016,
    text: "KY",
  },
  {
    key: 100000017,
    value: 100000017,
    text: "LA",
  },
  {
    key: 100000020,
    value: 100000020,
    text: "MA",
  },
  {
    key: 100000019,
    value: 100000019,
    text: "MD",
  },
  {
    key: 100000018,
    value: 100000018,
    text: "ME",
  },
  {
    key: 100000021,
    value: 100000021,
    text: "MI",
  },
  {
    key: 100000022,
    value: 100000022,
    text: "MN",
  },
  {
    key: 100000024,
    value: 100000024,
    text: "MO",
  },
  {
    key: 100000023,
    value: 100000023,
    text: "MS",
  },
  {
    key: 100000025,
    value: 100000025,
    text: "MT",
  },
  {
    key: 100000032,
    value: 100000032,
    text: "NC",
  },
  {
    key: 100000033,
    value: 100000033,
    text: "ND",
  },
  {
    key: 100000026,
    value: 100000026,
    text: "NE",
  },
  {
    key: 100000028,
    value: 100000028,
    text: "NH",
  },
  {
    key: 100000029,
    value: 100000029,
    text: "NJ",
  },
  {
    key: 100000030,
    value: 100000030,
    text: "NM",
  },
  {
    key: 100000027,
    value: 100000027,
    text: "NV",
  },
  {
    key: 100000031,
    value: 100000031,
    text: "NY",
  },
  {
    key: 100000034,
    value: 100000034,
    text: "OH",
  },
  {
    key: 100000035,
    value: 100000035,
    text: "OK",
  },
  {
    key: 100000036,
    value: 100000036,
    text: "OR",
  },
  {
    key: 100000037,
    value: 100000037,
    text: "PA",
  },
  {
    key: 100000038,
    value: 100000038,
    text: "RI",
  },
  {
    key: 100000039,
    value: 100000039,
    text: "SC",
  },
  {
    key: 100000040,
    value: 100000040,
    text: "SD",
  },
  {
    key: 100000041,
    value: 100000041,
    text: "TN",
  },
  {
    key: 100000042,
    value: 100000042,
    text: "TX",
  },
  {
    key: 100000043,
    value: 100000043,
    text: "UT",
  },
  {
    key: 100000045,
    value: 100000045,
    text: "VA",
  },
  {
    key: 100000044,
    value: 100000044,
    text: "VT",
  },
  {
    key: 100000046,
    value: 100000046,
    text: "WA",
  },
  {
    key: 100000048,
    value: 100000048,
    text: "WI",
  },
  {
    key: 100000047,
    value: 100000047,
    text: "WV",
  },
  {
    key: 100000049,
    value: 100000049,
    text: "WY",
  },
  {
    key: 226670000,
    value: 226670000,
    text: "DC",
  },
];
